import { useMemo } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Seo from '@/components/Seo'
import { categories, getInstructor, searchCourses } from '@/data/catalog'

function Courses() {
  const [params, setParams] = useSearchParams()
  const query = params.get('q') ?? ''
  const category = params.get('cat') ?? 'Todos'

  const results = useMemo(() => {
    const found = searchCourses(query)
    if (category === 'Todos') return found
    return found.filter((course) => course.category === category)
  }, [query, category])

  return (
    <>
      <Seo
        title="Cursos"
        description="Catálogo de HFCursos: escritura de marca, fotografía en película, dirección de arte y liderazgo de estudio."
      />
      <section className="mx-auto max-w-6xl px-5 py-12 lg:px-8">
        <p className="text-xs uppercase tracking-[0.28em] text-[#C41E3A]">Catálogo</p>
        <h1 className="mt-3 font-['Fraunces'] text-4xl">Cursos</h1>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-[#1E3A5F]/70">
          Programas breves con aula, presentaciones y certificado. Usa el buscador o filtra por oficio.
        </p>

        <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <label className="block max-w-md flex-1 text-sm">
            <span className="sr-only">Buscar en el catálogo</span>
            <input
              value={query}
              onChange={(event) => {
                const next = new URLSearchParams(params)
                if (event.target.value) next.set('q', event.target.value)
                else next.delete('q')
                setParams(next)
              }}
              placeholder="Buscar por título, oficio o instructor"
              className="w-full border-b border-[#1E3A5F]/25 bg-transparent py-2 outline-none"
            />
          </label>
          <div className="flex flex-wrap gap-2" role="group" aria-label="Filtrar por categoría">
            {categories.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => {
                  const next = new URLSearchParams(params)
                  if (item === 'Todos') next.delete('cat')
                  else next.set('cat', item)
                  setParams(next)
                }}
                className={`border px-3 py-1.5 text-xs ${
                  category === item ? 'border-[#1E3A5F] bg-[#1E3A5F] text-[#F4EFE6]' : 'border-[#1E3A5F]/20'
                }`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        {results.length === 0 ? (
          <p className="mt-16 text-sm text-[#1E3A5F]/60">No hay cursos con esos criterios. Prueba otra búsqueda.</p>
        ) : (
          <ul className="mt-10 grid gap-10 md:grid-cols-2">
            {results.map((course) => {
              const instructor = getInstructor(course.instructorId)
              return (
                <li key={course.id}>
                  <Link to={`/cursos/${course.slug}`} className="group block">
                    <img src={course.image} alt="" className="h-56 w-full object-cover" />
                    <div className="mt-4 flex items-baseline justify-between gap-4">
                      <h2 className="font-['Fraunces'] text-2xl group-hover:text-[#C41E3A]">{course.title}</h2>
                      <span className="text-xs text-[#1E3A5F]/50">{course.level}</span>
                    </div>
                    <p className="mt-2 text-sm text-[#1E3A5F]/70">{course.subtitle}</p>
                    <p className="mt-3 text-xs uppercase tracking-wide text-[#1E3A5F]/45">
                      {instructor?.name} · {course.duration} · {course.sessions} sesiones
                    </p>
                  </Link>
                </li>
              )
            })}
          </ul>
        )}
      </section>
    </>
  )
}

export default Courses
